import Grid from "@mui/material/Grid";

import {
  IconsGrid,
  IconsImage,
  ImageText,
} from "../styles/ProductStyles";
import type { ProductIcon } from "../types/productTypes";

type ProductIconListProps = {
  icons: ProductIcon[];
};

export const ProductIconList = ({ icons }: ProductIconListProps) => {
  return (
    <Grid container sx={{ margin: "30px 0" }}>
      {icons.map((item, index) => (
        <IconsGrid size={{ xs: 12, sm: 6 }} key={`icon_${item.id}`}>
          <IconsImage src={item.icon} alt={item.text} />
          <ImageText>{item.text}</ImageText>
        </IconsGrid>
      ))}
    </Grid>
  );
};